import { ReactElement, ReactNode } from "react";

export const isReactElement = (element: ReactNode): element is ReactElement =>
  element !== null && typeof element === 'object' && 'props' in element;